import { deleteCookie, getCookie, setCookie } from 'cookies-next/client';
import LOCALE_PREFERENCE_COOKIE_MAX_AGE, {
  LOCALE_SESSION_OVERRIDE_COOKIE,
  PROFILE_PREFERRED_LOCALE_COOKIE,
} from '@/core/constants/locale-preference-cookie';
import getLocalePreferenceCookieOptions from '@/core/utils/locale/locale-preference-cookie-options';

function readLocaleCookie(name: string): string | undefined {
  const value = getCookie(name);
  if (typeof value !== 'string' || !value.trim()) return undefined;
  return value.toLowerCase();
}

export function getLocaleSessionOverride(): string | undefined {
  return readLocaleCookie(LOCALE_SESSION_OVERRIDE_COOKIE);
}

export function setLocaleSessionOverride(locale: string): void {
  setCookie(
    LOCALE_SESSION_OVERRIDE_COOKIE,
    locale.toLowerCase(),
    getLocalePreferenceCookieOptions(),
  );
}

export function clearLocaleSessionOverride(): void {
  deleteCookie(LOCALE_SESSION_OVERRIDE_COOKIE, { path: '/' });
}

export function setProfilePreferredLocaleCookie(locale: string): void {
  setCookie(
    PROFILE_PREFERRED_LOCALE_COOKIE,
    locale.toLowerCase(),
    getLocalePreferenceCookieOptions(LOCALE_PREFERENCE_COOKIE_MAX_AGE),
  );
}

export function clearProfilePreferredLocaleCookie(): void {
  deleteCookie(PROFILE_PREFERRED_LOCALE_COOKIE, { path: '/' });
}

export function clearLoggedInLocaleCookies(): void {
  clearLocaleSessionOverride();
  clearProfilePreferredLocaleCookie();
}
